Librarian.Search.Window = new Class({
    Extends: Librarian.Window,
    Implements: Librarian.Search.Container,
    Binds: ["minimize"],

    options: {
        id: "searchWindow",
        height: 600,
        width: 810,
        padding: {
            right: 0
        }
    },

    initialize: function(options) {
        this.setOptions(options);
        this.options.contentURL = Librarian.path.getLibraryPath() + "search.html";

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString("search_advanced");

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();

        this.onSearchLoaded({
            id: this.options.id,
            onSearch: this.minimize
        });

        var itemEl = $("searchGo");
        if (itemEl) {
            itemEl.addOnClick(this.doSearch);
            itemEl.id = this.options.id + "_go";
        }

        itemEl = $("searchSize");
        if (itemEl) {
            this.options.width = itemEl.width.value.toInt();
            this.options.height = itemEl.height.value.toInt();

            // Then resize the window
            this.resize({
                width: this.options.width,
                height: this.options.height,
                centered: false
            });

            itemEl = $("searchWrapper");
            if (itemEl) {
                itemEl.style.height = (this.options.height - 65) + "px";

                if (Browser.ie7)
                    itemEl.style.width = (this.options.width - 15) + "px";
            }

            if (Browser.ie7 && this.contentEl)
                this.contentEl.style.width = (this.options.width - 15) + "px";
        }

        itemEl = $("searchCancel");
        if (itemEl) {
            itemEl.addOnClick(this.close);
            itemEl.id = this.options.id + "_cancel";
        }

        itemEl = null;
    },

    onClose: function() {
        this.parent();

        this.closeDatePickers();

        if (this.confirm)
            this.confirm.close();
    }
});
